<div class="container" [class.active]="selected | async">
  <filter-option [name]="name">
    <ng-content></ng-content>
  </filter-option>
  <div class="date">
    <advanced-filter-date
      *ngIf="selected | async"
      [name]="dateName"
      [operators]="operators"
      [min]="min"
    ></advanced-filter-date>
  </div>
</div>
